<template>
  <div style="display: contents">
    <v-menu offset-x :nudge-right="4" rounded="lg" transition="slide-x-transition" :min-width="240">
      <template #activator="{ on }">
        <NavItem
          class="help"
          icon="mdi-help-circle-outline"
          label="Help"
          :dot="hasNewEntries"
          v-on="on"
        />
      </template>

      <v-card>
        <v-list>
          <v-list-item
            v-for="action in menuItems"
            :key="action.label"
            active-class=""
            :href="action.href"
            :target="action.target"
            ripple
          >
            <v-list-item-content>
              <v-list-item-title data-test="help-item">
                {{ action.label }}
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action v-if="action.icon">
              <v-icon>{{ action.icon }}</v-icon>
            </v-list-item-action>
          </v-list-item>

          <v-divider class="my-2" />

          <v-list-item active-class="" ripple @click="openChangelog">
            <v-list-item-icon v-if="hasNewEntries" style="margin-right: 0; align-self: center">
              <vs-badge tone="info" variant="hint" />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title data-test="help-item">What’s new</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>

    <changelog-dialog v-if="showChangelog" @close="showChangelog = false" />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import NavItem from './NavItem.vue'
import ChangelogDialog from '@/components/changelog/ChangelogDialog.vue'
import { useChangelogBadge } from '@/components/changelog/useChangelogBadge'

const showChangelog = ref(false)
const { hasNewEntries, markAsSeen } = useChangelogBadge()

function openChangelog() {
  showChangelog.value = true
  markAsSeen()
}

interface MenuItem {
  label: string
  icon?: string
  href: string
  target: string
}

const menuItems: MenuItem[] = [
  {
    label: 'Support resources',
    href: 'https://ironsight.app/support-resources',
    target: '_blank',
  },
  {
    label: 'Terms of use',
    href: 'https://ironsight.app/terms-of-use',
    target: '_blank',
  },
  {
    label: 'Privacy policy',
    href: 'https://ironsight.app/privacy-policy',
    target: '_blank',
  },
]
</script>

<style scoped>
.help {
  margin-top: auto;
}
</style>
